import { TOUCH_BUFFER_MS } from "@angular/cdk/a11y";
import { ThisReceiver } from "@angular/compiler";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { i18nMetaToJSDoc } from "@angular/compiler/src/render3/view/i18n/meta";
import { ChangeDetectorRef, Component, EventEmitter, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment-timezone";
import { ActivatedRoute, Router } from "@angular/router";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { Console } from "console";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { Observable, Subject, Subscription, zip } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { ClienteInternacional } from "src/app/models/ClienteInternacional/ClienteInternacional";
import { Divisa } from "src/app/models/Divisa";
import { ComisionRecargo } from "src/app/models/Dte/ComisionRecargo";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { ExportacionTransporteDte } from "src/app/models/Dte/exportacionDte";
import { FacturaExportacion } from "src/app/models/Dte/FacturaExportacion";
import { IndicadorServicio } from "src/app/models/Dte/IndicadorServicio.enum";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { OptionsTransportDteEmitido } from "src/app/models/Dte/OptionsTransportDteEmitido";
import { ReferenciaDteEmitido } from "src/app/models/Dte/ReferenciaDteEmitido";
import { SolicitudDte } from "src/app/models/Dte/SolicitudDte";
import { TotalDteEmitido } from "src/app/models/Dte/TotalDteEmitido";
import { Folio } from "src/app/models/Folio/Folio";
import { GuiaDespacho } from "src/app/models/GuiaDespacho";
import { Producto } from "src/app/models/Producto/Producto";
import { Proveedor } from "src/app/models/Proveedor/Proveedor";
import { Receptor } from "src/app/models/Receptor/Receptor";
import { TipoDte } from "src/app/models/tipoDte";
import { DashboardService } from "src/app/services/dashboard.service";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { DteExportacionService } from "src/app/services/dte-exportacion.service";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { FoliosService } from "src/app/services/folios.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { ProductoService } from "src/app/services/producto.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { InvoicingButton } from "src/app/shared/models/InvoicingButton.enum";
import { Response } from "src/app/shared/models/Response";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { SubheaderService } from "src/app/_metronic/partials/layout/subheader/_services/subheader.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { runInThisContext } from "vm";
import { resourceLimits } from "worker_threads";
import { FacturaCompra } from "../../../models/Dte/FacturaCompra";
import { IDte } from "../../../models/Dte/IDte";
import { DocumentosEmitidosWidgetComponent } from "../../widgets/documentos-emitidos-widget/documentos-emitidos-widget.component";
import { TipoDespachoEnum } from "src/app/models/Dte/TipoDespacho.enum";
import { TipoTraslado } from "src/app/models/TipoTraslado";
import { NotaDebito } from "src/app/models/NotaDebito";
import { NotaCredito } from "src/app/models/NotaCredito";
import { OpcionesReferenciasDteComponent } from "./opciones-referencias-dte/opciones-referencias-dte.component";
import { EmisorService } from "src/app/services/emisor.service";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';


@Component({
	selector: "app-facturador-individual",
	templateUrl: "./facturador-individual.component.html",
	styleUrls: ["./facturador-individual.component.scss"],
})
export class FacturadorIndividualComponent implements OnInit {
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	codigoTipoDte: number;
	motivoNota: string = "";
	notaForm: FormGroup;
	tipoNota: number = -1;
	itemsCorreccion: string = "";
	disableDetailFields: boolean = false;
	public observacionesDte: string = '';
	public loading: boolean = false;
	//private newDte: DteEmitido = new DteEmitido();
	private newDte: IDte = new SolicitudDte();
	private subscriptions: Subscription[] = [];
	public dteExistente: DteEmitido;
	public listaDetallesFacturador: DetalleDte[] = [];
	private listaDetallesObservable$: Observable<DetalleDte[]>;
	private listaComisionesObservable$: Observable<ComisionRecargo[]>;
	private clienteIdObservable$: Observable<string>;
	private optionsRefObservable$: Observable<OptionsReferenceDteEmitido>;
	private optionsTransportObservable$: Observable<OptionsTransportDteEmitido>;
	private totalesDteObservable$: Observable<TotalDteEmitido>;
	public dteInvoice: DteEmitido = new DteEmitido();
	public dteSubmitted: boolean = false;
	public listDivisas: Divisa[] = [];
	public showInGuide: boolean = false;
	public showTransporte: boolean = false;
	public dontShowInSettlement: boolean = false;
	public showInSettlement = false;
	private listElementsWithTax: boolean = false;
	public showInExportInvoice: boolean = false;
	public receptor: any = null;
	public porcentajeIva: number = environment.taxPercentage;
	private invoiceTypeByRoute: Observable<any>; //observable for parameter from route,
	public InvoiceType = InvoiceType;
	public invoiceType: InvoiceType = InvoiceType.Factura;
	private exportacionObservable$: Observable<ExportacionTransporteDte>;
	public loadingDivisas$: Observable<boolean>;
	public invalidSize$: Observable<boolean>;
	public invalidSize: boolean = false;
	public buttonAction$;
	private destroySubscriptions$: Subject<boolean> = new Subject<boolean>();
	public listaGuiasFacturables: DteEmitido[] = [];
	public configScroll: PerfectScrollbarConfigInterface = {};
	@ViewChild("GuidesListToInvoices") listaGuiasModalRef: any;
	@ViewChild('opcionesRef') opcionesRef: OpcionesReferenciasDteComponent;
	private guiasModal: any;
	public selectedGuides: DteEmitido[] = []; //dtes seleccionados por checkbox
	private currentGlobaleCheckGuidRefs: boolean = false;
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	private responseResult: string;
	private foliosData: Folio[] = [];
	private currentEmisorId: string = this.tokenService.getCompany();
	private currentSucursalId: string = this.tokenService.getSubsidiary();
	private groupedFolios: Object;
	private listFolioResumen: any[] = [];
	private tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
	private currentGrupoFolio: any;

	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	constructor(
		private facturador: FacturacionIndividualService,
		private tokenService: TokenStorageService,
		private ref: ChangeDetectorRef,
		private utilities: UtilitiesService,
		private dashboard: DashboardService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private localStorage: LocalStorageService,
		private productService: ProductoService,
		private subheaderService: SubheaderService,
		private modalService: NgbModal,
		private dteService: DteEmitidosService,
		private dteExportaService: DteExportacionService,
		private foliosService: FoliosService,
		private emisorService: EmisorService,
		private fb: FormBuilder,
		private sessionUserService: SessionUserService
	) {
		this.listaDetallesObservable$ = this.facturador.detalleDteListObservable;
		this.listaComisionesObservable$ = this.facturador.detalleComisionDteListObservable;
		this.clienteIdObservable$ = this.facturador.clienteIdObservable;
		this.optionsRefObservable$ = this.facturador.opcionesReferenciaObservable;
		this.optionsTransportObservable$ = this.facturador.opcionesTransporteObservable;
		this.totalesDteObservable$ = this.facturador.resumenTotalesObservable;
		this.exportacionObservable$ = this.facturador.exportacionTransporteObservable;
		this.loadingDivisas$ = this.dashboard.isLoadingDailyDivisas;
		this.invalidSize$ = this.facturador.invalidSizeObservable;
		this.buttonAction$ = this.facturador.buttonActionsObservable;
	}

	ngOnInit(): void {
		this.dontShowInSettlement = false;
		this.showInSettlement = false;
		this.selectedGuides = [];
		this.sessionUserService.verificarSesionUsuario();
		

		const detallesSubscription = this.listaDetallesObservable$.subscribe((list) => {
			this.newDte.detalleDte = list.filter((detail) => detail.cantidad > 0);
		});
		const comisionesSubscription = this.listaComisionesObservable$.subscribe((list) => {
			this.newDte.comisionesCargosDte = list.filter((detail) => detail.cantidad > 0);
		});
		const clienteSubscription = this.clienteIdObservable$.subscribe((rut) => {
			this.newDte.rutReceptor = rut ? rut.substring(0, rut.length - 2) : "66666666";
			this.newDte.rutReceptorDv = rut ? rut.substring(rut.length - 1) : "6";
			if (this.newDte instanceof FacturaExportacion) {
				this.newDte.clienteInternacionalId = +rut;
			}
		});
		const optionsTransportSubscription = this.optionsTransportObservable$.subscribe((optionTransport) => {
			this.newDte.guiaDespacho = new GuiaDespacho();
			if (optionTransport != null) {
				this.newDte.guiaDespacho.rutTransporte = optionTransport.rutTransporte;
				this.newDte.guiaDespacho.patente = optionTransport.patente;
				this.newDte.guiaDespacho.rutChofer = optionTransport.rutChofer;
				this.newDte.guiaDespacho.nombreChofer = optionTransport.nombreChofer;
				this.newDte.guiaDespacho.dvChofer = optionTransport.dvChofer;
				this.newDte.guiaDespacho.dvTransporte = optionTransport.dvTransporte;

				// **Asignar los nuevos campos**
				this.newDte.mnzRolOrigen = optionTransport.mnzRolOrigen;
				this.newDte.prdRolOrigen = optionTransport.prdRolOrigen;
				this.newDte.codPlanConaf = optionTransport.codPlanConaf;
				this.newDte.latitudOrigenMadera = optionTransport.latitudOrigenMadera;
				this.newDte.longitudOrigenMadera = optionTransport.longitudOrigenMadera;
				this.newDte.comunaOrigenId = optionTransport.comunaOrigenId;
			} else {
				this.newDte.guiaDespacho = null;
			}
		});
		const optionsRefSubscription = this.optionsRefObservable$.subscribe((optionsRef) => {
			this.listElementsWithTax = optionsRef.sonDetallesConIVA;
			this.newDte.indicadorMontosNetos = !optionsRef.sonDetallesConIVA;
			this.newDte.tipoMoneda = optionsRef.tipoMoneda;
			this.newDte.tipoMonedaAduana = optionsRef.tipoMonedaAduana;
			this.newDte.codigoMonedaAduana = optionsRef.codigoMonedaAduana;
			if (optionsRef.haveDteReference) {
				//compatible with old invoice generation
				if (optionsRef.listaReferencias && optionsRef.listaReferencias[0]) {
					this.newDte.razonReferencia = optionsRef.listaReferencias[0].razonReferencia;
					this.newDte.folioReferencia = optionsRef.listaReferencias[0].folioReferencia;
					this.newDte.fechaReferencia = optionsRef.listaReferencias[0].fechaDteReferenciado;
					this.newDte.codigoTipoDteReferencia = optionsRef.listaReferencias[0].codigoTipoDteReferencia;
				}
				//new multiple references invoice generation
				this.newDte.listaReferenciasDteEmitido = optionsRef.listaReferencias;
			} else if (!optionsRef.haveDteReference) {
				this.newDte.razonReferencia = undefined;
				this.newDte.folioReferencia = undefined;
				this.newDte.fechaReferencia = undefined;
				this.newDte.codigoTipoDteReferencia = undefined;
				this.newDte.rutEmisor = undefined;
			}
			//pass global reference to list of guide references
			if (optionsRef.globalReferenceForGuideRefs != this.currentGlobaleCheckGuidRefs && optionsRef.globalReferenceForGuideRefs != undefined) {
				this.currentGlobaleCheckGuidRefs = optionsRef.globalReferenceForGuideRefs;
				if (optionsRef.globalReferenceForGuideRefs && this.selectedGuides && this.selectedGuides.length > 0) {
					this.guideToGroupedReferenceItem(this.selectedGuides);
				} else if (!optionsRef.globalReferenceForGuideRefs && this.selectedGuides && this.selectedGuides.length > 0) {
					this.processGuideToReferences(this.selectedGuides);
				}
			}
		});
		const totalesDteSubscription = this.totalesDteObservable$.subscribe((totales) => {
			if (totales) {
				this.newDte.neto = totales.netoDte;
				this.newDte.exento = totales.exentoDte;
				this.newDte.iva = totales.ivaDte;
				this.newDte.total = totales.totalDte;
				this.newDte.tipoDteId = totales.tipoDteId;
				this.newDte.codigoTipoDte = totales.codigoTipoDte;

				this.sendTipoFolio(totales.codigoTipoDte);
				if (this.newDte.codigoTipoDte == 33 || this.newDte.codigoTipoDte == 34) {
					this.newDte.indicadorServicio = IndicadorServicio.BoletasVentaYServicios;
					this.showInGuide = false;
				}
				if (this.newDte.codigoTipoDte == 33 || this.newDte.codigoTipoDte == 43) {
					this.newDte.tieneIvaTerceros = totales.TieneIvaTerceros;
					this.newDte.ivaTerceros = totales.ivaTerceros;
					this.newDte.ivaPropio = totales.ivaPropio;
				}
				this.newDte.descuentoGlobal = +totales.descuentoGlobal;
				let dateMoment = moment(totales.fechaEmision, "DD/MM/YYYY", true);
				this.newDte.fecha = dateMoment.toDate();
				let objFormato = totales.formato;
				this.newDte.formato = totales.formato ? totales.formato.size : 0;
				this.newDte.diasVencimiento = totales.diasVencimiento;
				this.newDte.formaPagoEnum = totales.formaPago;
				this.newDte.FormaPagoExportacionEnum = totales.formaPagoExportacion;
				this.newDte.tipoMoneda = totales.otraMonedaEnt ? totales.otraMonedaEnt.tipoMoneda : "CLP";
				this.newDte.otraMonedaEnt = totales.otraMonedaEnt;
				this.newDte.DescuentoRecargoEnts = totales.descuentoRecargoEnt ? [totales.descuentoRecargoEnt] : undefined;
				this.newDte.impuestos = totales.montoImpuestos ? totales.montoImpuestos : undefined;
				//this.newDte.comisionCargoDte = totales.comisionCargos
				if (this.newDte instanceof FacturaCompra) {
					this.newDte.retencion = totales.retencionIva;
				}
				if (this.newDte.guiaDespacho) {
					this.newDte.guiaDespacho.tipoTraslado = totales.tipoTraslado;
					this.newDte.guiaDespacho.tipoDespacho = totales.tipoDespacho;
				}
				if (this.newDte.codigoTipoDte == 43) {
					this.newDte.comisionCargo = totales.totalComisionCargos + totales.exentoComisionCargos + totales.netoComisionCargos + totales.ivaComisionCargos;
					this.newDte.tipoMoneda = "CLP";
				}
				if (this.newDte instanceof FacturaExportacion) {
					// this.newDte.modalidadVentaId = totales.modalidadVentaId;
					// this.newDte.modalidadVentaGlosa = totales.modalidadVentaNombre;
					// this.newDte.clausulaVentaGlosa = totales.clausulaVenta;
					this.newDte.montoClausulaVenta = totales.montoClausulaVenta;
					this.newDte.setTotalesData(totales);
				}
			}
		});
		const divisasSubscription = this.dashboard.getDailyDivisas().subscribe((divisas) => {
			this.listDivisas = divisas.data;
			this.facturador.updateDivisas(this.listDivisas);
		});

		const exportacionSubbscription = this.exportacionObservable$.subscribe((exportacion) => {
			if (this.newDte instanceof FacturaExportacion) {
				this.newDte.transporte = exportacion;
				this.newDte.setExportData(this.newDte.transporte);
			}
		});

		const invalidSizeSub = this.invalidSize$.subscribe((isInvalid) => {
			this.invalidSize = isInvalid;
		});
		const buttonActionSubscription = this.buttonAction$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((action) => {
			if (action == InvoicingButton.Emitir) {
				this.consolidateDte(true);
			}
			if (action == InvoicingButton.Previsualizar) {
				this.consolidateDte(false);
			}
			if (action == InvoicingButton.Cancelar) {
				this.returnToMaintainer();
			}
			if (action == InvoicingButton.FacturarGuias) {
				this.consultaGuiasFacturablesCliente();
			}
		});

		this.subscriptions.push(detallesSubscription);
		this.subscriptions.push(clienteSubscription);
		this.subscriptions.push(optionsTransportSubscription);
		this.subscriptions.push(optionsRefSubscription);
		this.subscriptions.push(totalesDteSubscription);
		this.subscriptions.push(divisasSubscription);
		this.subscriptions.push(exportacionSubbscription);
		this.subscriptions.push(comisionesSubscription);
		this.subscriptions.push(invalidSizeSub);
		this.subscriptions.push(buttonActionSubscription);
		this.getStateFromRoute();
		this.getDocTypeParamFromStateRoute();

		if (this.invoiceType == InvoiceType.NotaCredito) {
			this.codigoTipoDte = 61;
			Swal.fire({
				title: "Advertencia",
				text: "Esta nota de crédito estará referenciando a documentos que no tenemos registrados en nuestros sistemas, por lo que no podemos garantizar que esta sea aceptada. Es su responsabilidad asegurarse de que el documento referenciado esté en regla en el SII y que los datos coincidan con el origen, de lo contrario, esta podría ser rechazada.",
				icon: "warning",
				confirmButtonText: "Entendido",
			});
			this.notaForm = this.fb.group({
				motivo: [null, Validators.required],
				itemsCorreccion: [""],
			});
		} else if (this.invoiceType == InvoiceType.NotaDebito) {
			this.codigoTipoDte = 56;
			Swal.fire({
				title: "Advertencia",
				text: "Esta nota de débito estará referenciando a documentos que no tenemos registrados en nuestros sistemas, por lo que no podemos garantizar que esta sea aceptada. Es su responsabilidad asegurarse de que el documento referenciado esté en regla en el SII y que los datos coincidan con el origen, de lo contrario, esta podría ser rechazada.",
				icon: "warning",
				confirmButtonText: "Entendido",
			});
			this.notaForm = this.fb.group({
				motivo: [null, Validators.required],
				itemsCorreccion: [""],
			});
		}
	}

	onObservacionesChange(valor: string) {
		this.observacionesDte = valor;
	  }

	getFormatSizes(emisorId, tipoDteId) {
		this.facturador.getFormatSizeItems(emisorId, tipoDteId).subscribe(
			(result) => {
				this.facturador.updateFormatoDte(result.data);
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "No tiene habilitado este documento",
					text: "Es posible que no tenga la aprobación del SII aún. Contacte con soporte. Error 55.110.12",
					showConfirmButton: true,
				}).then(() => {
					this.returnToMaintainer();
				});
				//Swal.fire({icon:'error',title:'Error en plantilla',text:'No se obtuvo el registro de plantilla para el tipo de documento a emitir'})
			}
		);
	}

	onMotivoChange(motivo: string) {
		this.motivoNota = motivo;
		this.notaForm.get("motivo").setValue(motivo);
	}
	onTipoNotaSeleccionado(tipoNota: number) {
		this.tipoNota = tipoNota;
		if (this.tipoNota === -1) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en el motivo";
			this.currentSwal.text = `El motivo seleccionado no es válido. Seleccione un motivo de la lista disponible.`;
			this.currentSwal.fire();
		}

		if (this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) {
			this.disableDetailFields = true;
			this.clearDetailFields();
			this.notaForm.get("itemsCorreccion").setValidators([Validators.required]);
		} else {
			this.disableDetailFields = false;
			this.notaForm.get("itemsCorreccion").clearValidators();
			this.notaForm.get("itemsCorreccion").setValue("");
		}
		this.notaForm.get("itemsCorreccion").updateValueAndValidity();
	}
	clearDetailFields() {
		this.facturador.clearAllDetails();
	}
	buildNotaCredito(tipoNota: number): NotaCredito {
		const notaCredito = new NotaCredito();
		notaCredito.motivoString = this.notaForm.get("motivo")?.value;
		notaCredito.tipoNota = tipoNota;
		if (tipoNota === 1 || tipoNota === 2) {
			notaCredito.neto = Math.round(this.newDte.neto);
			notaCredito.iva = Math.round(this.newDte.iva);
			notaCredito.total = Math.round(this.newDte.total);
		}
		if (this.newDte.listaReferenciasDteEmitido) {
			notaCredito.razonReferencias = this.newDte.listaReferenciasDteEmitido.map((ref) => `${ref.razonReferencia}`).join("; ");
			notaCredito.folio = parseInt(this.newDte.listaReferenciasDteEmitido.map((ref) => ref.folioReferencia).join("; "), 10);
			notaCredito.fechaNota = this.newDte.listaReferenciasDteEmitido.map((ref) => ref.fechaDteReferenciado).join("; ");
		} else {
			notaCredito.razonReferencias = "";
		}
		if (tipoNota === 1 || tipoNota === 2) {
			if (this.newDte.detalleDte) {
				notaCredito.itemsNota = this.newDte.detalleDte.filter((detalle) => detalle.cantidad > 0).map((detalle) => Object.assign(new DetalleDte(), detalle));
			}
			
		}
		if (tipoNota === 2) {
			const textoCorreccion = this.notaForm.get("itemsCorreccion")?.value?.trim();
			if (notaCredito.itemsNota == null) {
				notaCredito.itemsNota = [];
			}

			if (textoCorreccion) {
				notaCredito.itemsNota.push({
					descripcion: textoCorreccion,
				});
			}
		}
		return notaCredito;
	}

	/*buildNotaDebito(tipoNota: number): NotaDebito {
		const notaDebito = new NotaDebito();
		notaDebito.motivoString = this.notaForm.get("motivo")?.value;
		notaDebito.tipoNota = tipoNota;
		if (tipoNota === 1 || tipoNota === 2) {
		
		}
		return notaDebito;
	}*/

	ngAfterContentInit() {
		setTimeout(() => {
			this.subheaderService.setTitle("");
			this.subheaderService.setBreadcrumbs([]);
		}, 0.1);
	}

	addClientToInvoiceRequest(client: any) {
		this.dteInvoice.rutReceptor = client.rutString;
		this.newDte.razonSocial = client.razonSocial;

		this.receptor = client;

		if (this.newDte instanceof FacturaExportacion) {
			this.newDte.clienteInternacionalId = client.clienteInternacionalId;
			this.newDte.razonSocial = client.razonSocial;
		}
	}
	addProveedorToInvoiceRequest(proveedor: Proveedor) {
		this.receptor = proveedor;
		this.dteInvoice.rutReceptor = proveedor.rutProveedor;
		this.newDte.razonSocial = proveedor.razonSocial;
		this.receptor.emisorId = this.currentEmisorId;
		if (this.newDte instanceof FacturaCompra) {
			this.newDte.rutProveedor = proveedor.rutProveedor;
		}
	}

	consolidateDte(sender: boolean) {
		//verificar si es una transferencia interna
		const isInternalTransfer = this.newDte.guiaDespacho?.tipoTraslado === 5;
		this.newDte.observaciones = this.observacionesDte;

		if (!(this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) && (this.newDte.detalleDte == null || (this.newDte.detalleDte.length <= 1 && this.newDte.detalleDte.some((detalle) => detalle.cantidad == 0)))) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Detalles vacíos";
			this.currentSwal.text = "No se ha ingresado ningún detalle para la emisión del documento.";
			this.currentSwal.fire();
			return;
		}
		if (this.showInSettlement) {
			this.facturador.clearUnfilledComisionItems();
		} else {
			this.facturador.clearUnfilledItems();
		}
		//check if every component has send data for the new Dte object
		let usuarioId = (this.tokenService.getUser() as SessionUser).id;
		let sucursalId = this.tokenService.getSubsidiary();
		let emisorId = this.tokenService.getCompany();
		const valor = this.opcionesRef.optionsReferenceFormGroup.get('detallesExentos').value;
		this.emisorService.updateDetallesIvaIncluido(emisorId, valor).subscribe({
			error: (err) => console.error('No se pudo actualizar preferencia', err)
		  });
		this.newDte.receptorEnt = this.receptor;
		this.newDte.emisorId = emisorId;

		this.newDte.detalleDte.forEach((detalle) => {
			detalle.nroitem = this.newDte.detalleDte.indexOf(detalle) + 1;
			detalle.totalImpuestosAdicionales = !detalle.esExento ? Math.round(detalle.totalImpuestosAdicionales) : 0;
			if (detalle.esExento) detalle.impuestosAdicionales = [];
			if (detalle.impuestosAdicionales && detalle.impuestosAdicionales.length > 0 && detalle.totalImpuestosAdicionales > 0) detalle.impuestosAdicionales.forEach((imp) => (imp.valor = Math.round(imp.valor)));
			// if(this.listElementsWithTax){
			//   detalle = JSON.parse(JSON.stringify({...this.setDetailWithoutTax(detalle)}));
			// }
		});
		if (this.showInSettlement) {
			this.newDte.comisionesCargosDte.forEach((detalle) => {
				detalle.nroItem = this.newDte.comisionesCargosDte.indexOf(detalle) + 1;
			});
		}

		if (this.currentGrupoFolio == undefined) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Sin registro de folios";
			this.currentSwal.text = "No hay registro de folios disponibles para emitir el tipo de documento actual";
			this.currentSwal.fire();
			return;
		}
		if (this.currentGrupoFolio && this.currentGrupoFolio.codigoSii == this.newDte.codigoTipoDte && this.currentGrupoFolio.suma == 0) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Folios insuficientes";
			this.currentSwal.text = "No hay folios disponibles para emitir el tipo de documento " + this.currentGrupoFolio.nombre;
			this.currentSwal.fire();
			return;
		}
		if (!this.newDte.tipoDteId) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Omisión de Datos";
			this.currentSwal.text = "No se ha seleccionado el tipo de documento a generar";
			this.currentSwal.fire();
			return;
		}
		if (this.newDte.otraMonedaEnt && this.newDte.otraMonedaEnt.tipoMoneda == "OTHER" && this.newDte.otraMonedaEnt.tipoCambio == 0) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en valor de moneda";
			this.currentSwal.text = "El valor de moneda seleccionado debe ser superior a cero";
			this.currentSwal.fire();
			return;
		}
		if (!(this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) && !isInternalTransfer && this.getTotalOfDetails(this.newDte) <= 0) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Montos";
			this.currentSwal.text = "El total de detalles indicado no puede ser menor a cero.";
			this.currentSwal.fire();
			return;
		}

		// Validación: Detalles con montos nulos o negativos
		if (!(this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) && !isInternalTransfer && this.someNullDetail(this.newDte)) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Montos";
			this.currentSwal.text = "Los elementos de detalle indicados no pueden tener valores menores a cero.";
			this.currentSwal.fire();
			return;
		}

		if (this.newDte.neto <= 5 && this.newDte.exento <= 5 && this.newDte.total != this.newDte.exento && this.invoiceType != InvoiceType.FacturaExportacion && this.invoiceType != InvoiceType.LiquidacionFactura && this.newDte.descuentoGlobal == 0) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Montos";
			this.currentSwal.text = "El neto total del documento debe ser mayor a $5";
			this.currentSwal.fire();
			return;
		}
		if (this.newDte.formato == 0) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Formato";
			this.currentSwal.text = "No ha asignado una plantilla para el tipo de documento seleccionado o el formato a utilizar considera 0 lineas de detalle";
			this.currentSwal.fire();
		}
		if (this.invalidSize) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Detalles";
			this.currentSwal.text = "Los elementos de detalle son mayores a los permitidos en el formato del documento. La cantidad máxima de líneas de detalle permitidas en la lista según el formato actualmente seleccionado es de " + this.newDte.formato + " y se están utilizando " + this.facturador.currentSize + " líneas de detalle.";
			this.currentSwal.fire();
			return;
		}
		if ((this.invoiceType != InvoiceType.Boleta && this.invoiceType != InvoiceType.FacturaCompra && this.invoiceType != InvoiceType.FacturaExportacion && (this.newDte.rutReceptor == null || this.newDte.rutReceptor == undefined || this.newDte.rutReceptor == "" || this.newDte.rutReceptor == "66666666")) || (this.invoiceType == InvoiceType.FacturaExportacion && !(this.newDte as FacturaExportacion).clienteInternacionalId)) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Cliente";
			this.currentSwal.text = "No se ha asignado correctamente el cliente asociado al documento, por favor intente nuevamente";
			this.currentSwal.fire();
			return;
		}
		if (this.invoiceType == InvoiceType.FacturaCompra && this.newDte instanceof FacturaCompra && (this.newDte.rutProveedor == "" || this.newDte.rutProveedor == undefined)) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Proveedor";
			this.currentSwal.text = "No se ha asignado correctamente el proveedor asociado al documento, por favor intente nuevamente";
			this.currentSwal.fire();
			return;
		}
		if (!this.newDte.tipoMoneda) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Divisa";
			this.currentSwal.text = "No se ha asignado correctamente la divisa asociada al documento, por favor intente nuevamente";
			this.currentSwal.fire();
			return;
		}
		if (this.newDte.descuentoGlobal > this.getTotalOfDetails(this.newDte)) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en descuento";
			this.currentSwal.text = "El descuento ingresado es mayor al monto total de detalles del documento";
			this.currentSwal.fire();
			return;
		}
		if (this.newDte.indicadorMontosNetos && this.newDte.impuestos > 0) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en Montos con Impuestos";
			this.currentSwal.text = "Si los productos ingresados tienen impuestos especificos, no puede indicarse que sean productos con impuestos incluidos, solamente pueden ser a valor neto";
		}
		if (this.invoiceType == InvoiceType.GuiaDespacho && this.newDte.guiaDespacho.tipoDespacho != TipoDespachoEnum.Receptor) {
			if (this.newDte.guiaDespacho.rutChofer == 0 || this.newDte.guiaDespacho.rutChofer == undefined || this.newDte.guiaDespacho.rutTransporte == 0 || this.newDte.guiaDespacho.rutTransporte == 0 || this.newDte.guiaDespacho.nombreChofer == undefined || this.newDte.guiaDespacho.nombreChofer == undefined || this.newDte.guiaDespacho.patente == "" || this.newDte.guiaDespacho.patente == undefined) {
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Datos de Transporte Incompletos";
				this.currentSwal.text = "Ingrese todos los datos correspondientes al modulo de transporte";
				this.currentSwal.fire();
				return;
			}
		}
		if (this.invoiceType == InvoiceType.FacturaExportacion && this.exportWithErrors(this.newDte as FacturaExportacion)) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error en datos de Exportación";
			this.currentSwal.text = "Los datos de la sección de transporte se encuentran incompletos, favor revisar y completar e intente emitir la factura de exportación nuevamente";
			this.currentSwal.fire();
			return;
		}
		if (this.invoiceType === InvoiceType.NotaDebito || this.invoiceType === InvoiceType.NotaCredito) {
			if (this.notaForm.invalid) {
				this.currentSwal.icon = "error";
				if (this.invoiceType === InvoiceType.NotaCredito) {
					this.currentSwal.title = "Error en emisión de Nota de Crédito";
					this.currentSwal.text = "Debe indicar un motivo para emitir la nota de crédito.";
				} else {
					this.currentSwal.title = "Error en emisión de Nota de Débito";
					this.currentSwal.text = "Debe indicar un motivo para emitir la nota de débito.";
				}
				this.currentSwal.fire();
				return;
			}
		
			if (!this.newDte.listaReferenciasDteEmitido || this.newDte.listaReferenciasDteEmitido.length === 0) {
				this.currentSwal.icon = "error";
				if (this.invoiceType === InvoiceType.NotaCredito) {
					this.currentSwal.title = "Error en emisión de Nota de Crédito";
					this.currentSwal.text = "Debe seleccionar al menos un documento de referencia para emitir la nota de crédito.";
				} else {
					this.currentSwal.title = "Error en emisión de Nota de Débito";
					this.currentSwal.text = "Debe seleccionar al menos un documento de referencia para emitir la nota de débito.";
				}
				this.currentSwal.fire();
				return;
			}
		}
		
		//if (this.invoiceType != InvoiceType.GuiaDespacho) this.newDte.guiaDespacho = null;
		if (this.invoiceType != InvoiceType.LiquidacionFactura) this.newDte.comisionesCargosDte = null;

		this.cleanEmptyDetails();
		// if(this.listElementsWithTax){
		//   this.newDte.detalleDte = this.newDte.detalleDte.map(detalle =>{
		//     return detalle = this.setDetailWithoutTax(detalle);
		//   })
		// }
		if (sender) {
			switch (this.invoiceType) {
				case InvoiceType.Boleta: {
					this.sendDteBoleta(usuarioId, sucursalId, this.newDte);
					break;
				}
				case InvoiceType.Factura: {
					this.sendDte(usuarioId, sucursalId, this.newDte);
					break;
				}
				case InvoiceType.FacturaCompra: {
					this.sendFacturaCompra(usuarioId, sucursalId, this.newDte);
					break;
				}
				case InvoiceType.GuiaDespacho: {
					this.sendDteGuide(usuarioId, sucursalId, this.newDte);
					break;
				}
				case InvoiceType.LiquidacionFactura: {
					this.sendDteSettlement(usuarioId, sucursalId, this.newDte);
					break;
				}
				case InvoiceType.FacturaExportacion: {
					this.sendFacturaExportacion(usuarioId, sucursalId, this.newDte);
					break;
				}
				case InvoiceType.NotaDebito: {
					this.sendNotaDebito(usuarioId, sucursalId, this.newDte);
					break;
				}
				case InvoiceType.NotaCredito: {
					const notaCredito = this.buildNotaCredito(this.tipoNota);
					this.sendNotaCredito(usuarioId, sucursalId, notaCredito, this.newDte);
					break;
				}
			}
		} else {
			this.previzualiseDte(usuarioId, sucursalId, this.newDte);
		}
	}

	mostrarPDF(): boolean {
		// Consulta si el atributo ha sido establecido por Cypress
		return document.body.getAttribute("data-mostrar-pdf") !== "false";
	}

	sendDte(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		this.scrollToTop();
		if (this.newDte.listaReferenciasDteEmitido) {
			this.checkAndAddGuideReferences();
		}
		this.facturador.sendDte(usuarioId, sucursalId, dteToSend).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data;
				//Cuando es test, esto no se llama
				if (this.mostrarPDF()) {
					this.getPdfOfInvoice(this.responseResult, this.invoiceType);
				}
				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
				this.ref.detectChanges();
				this.currentSwal.title = "Documento Emitido";
				this.currentSwal.text = "El documento se ha emitido correctamente";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
				this.newDte = new DteEmitido();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir el documento, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}
	sendDteGuide(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		this.scrollToTop();
		this.facturador.sendDteGuide(usuarioId, sucursalId, dteToSend).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data;
				if (this.mostrarPDF()) {
					this.getPdfOfInvoice(this.responseResult, this.invoiceType);
				}

				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
				this.ref.detectChanges();
				this.currentSwal.title = "Documento Emitido";
				this.currentSwal.text = "El documento se ha emitido correctamente";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
				this.newDte = new DteEmitido();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir el documento, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}
	sendDteSettlement(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		this.scrollToTop();
		dteToSend.documentosLiquidados = [];
		dteToSend.detalleDte.forEach((detail) =>
			detail.relatedDocumentsIds.forEach((id) => {
				dteToSend.documentosLiquidados.push(id);
			})
		);
		this.facturador.sendDteSettlement(usuarioId, sucursalId, dteToSend).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data;
				this.getPdfOfInvoice(this.responseResult, this.invoiceType);

				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
				this.newDte = new DteEmitido();
				this.ref.detectChanges();
				this.currentSwal.title = "Documento Emitido";
				this.currentSwal.text = "El documento se ha emitido correctamente";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir el documento, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}
	sendDteBoleta(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		this.scrollToTop();
		dteToSend.sucursalId = sucursalId;
		this.facturador.sendDteBoleta(usuarioId, sucursalId, dteToSend).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data;
				this.ref.detectChanges();
				this.currentSwal.title = "Boleta Emitida";
				this.currentSwal.text = "La boleta se ha emitido correctamente";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
				if (this.mostrarPDF()) {
					this.getPdfOfInvoice(this.responseResult, this.invoiceType);
				}

				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir la boleta, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}

	sendFacturaCompra(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		this.scrollToTop();
		this.facturador.sendFacturaCompraRequest(usuarioId, sucursalId, dteToSend).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data;
				this.ref.detectChanges();
				this.currentSwal.title = "Factura de Compra Emitida";
				this.currentSwal.text = "La factura de compra se ha emitido correctamente";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
				if (this.mostrarPDF()) {
					this.getPdfOfInvoice(this.responseResult, this.invoiceType);
				}
				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir la factura de compra, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}

	sendFacturaExportacion(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		this.scrollToTop();
		(dteToSend as FacturaExportacion).rewriteDetailsByForeignCurrency();
		dteToSend.otraMonedaEnt.tipoMoneda = "CLP";
		(dteToSend as FacturaExportacion).rewriteTotals();
		let dte = (dteToSend as FacturaExportacion).toDteEmitido();
		dte.dteExportacionEnt = dteToSend as FacturaExportacion;
		dte.codigoTipoDte = 110;
		this.facturador.sendFacturaExportacion(usuarioId, sucursalId, dte).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data;
				this.ref.detectChanges();
				this.currentSwal.title = "Factura de Exportación Emitida";
				this.currentSwal.text = "La factura de exportación se ha emitido correctamente";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
				if (this.mostrarPDF()) {
					this.getPdfOfInvoice(this.responseResult, this.invoiceType);
				}

				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir la factura de exportación, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}

	sendNotaDebito(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		const notaDebito = new NotaDebito();
		notaDebito.motivoString = this.notaForm.get("motivo").value;
		notaDebito.tipoNota = this.tipoNota;
		if (this.newDte.listaReferenciasDteEmitido) {
			notaDebito.razonReferencias = this.newDte.listaReferenciasDteEmitido.map((ref) => `${ref.razonReferencia}`).join("; ");
			notaDebito.folio = parseInt(this.newDte.listaReferenciasDteEmitido.map((ref) => ref.folioReferencia).join("; "), 10);
		} else {
			notaDebito.razonReferencias = "";
		}
		this.facturador.sendNotaDebito(usuarioId, sucursalId, notaDebito, dteToSend as DteEmitido).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data.dteId;
				this.ref.detectChanges();
				this.currentSwal.title = "Nota de Débito Emitida";
				this.currentSwal.text = "La nota de débito se ha emitido correctamente.";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
				if (this.mostrarPDF()) {
					this.getPdfOfInvoice(this.responseResult, this.invoiceType);
				}

				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir la nota de débito, intente nuevamente o contacte a su administrador." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}

	sendNotaCredito(usuarioId: string, sucursalId: string, notaCredito: NotaCredito, dteToSend: IDte): void {
		this.loading = true;
		this.facturador.sendNotaCredito(usuarioId, sucursalId, notaCredito, dteToSend as DteEmitido).subscribe(
			(result) => {
				this.loading = false;
				this.responseResult = result.data.dteId;
				this.ref.detectChanges();
				this.currentSwal.title = "Nota de Crédito Emitida";
				this.currentSwal.text = "La nota de crédito se ha emitido correctamente.";
				this.currentSwal.icon = "success";
				this.currentSwal.fire();
				if (this.mostrarPDF()) {
					this.getPdfOfInvoice(this.responseResult, this.invoiceType);
				}
				this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir la nota de Crédito, intente nuevamente o contacte a su administrador." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}

	previzualiseDte(usuarioId: string, sucursalId: string, dteToSend: IDte) {
		this.loading = true;
		this.scrollToTop();
		if (this.invoiceType == InvoiceType.FacturaExportacion) {
			(dteToSend as FacturaExportacion).rewriteDetailsByForeignCurrency();
			dteToSend.otraMonedaEnt.tipoMoneda = "CLP";
			(dteToSend as FacturaExportacion).rewriteTotals();
			let dte = (dteToSend as FacturaExportacion).toDteEmitido();
			dte.dteExportacionEnt = dteToSend as FacturaExportacion;
			dte.codigoTipoDte = 110;
			dte.FormaPagoExportacion = dteToSend.FormaPagoExportacion;
			dteToSend = { ...dte };
		}
		this.facturador.previewDte(usuarioId, sucursalId, dteToSend).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				let pdfBlob = this.utilities.convertB64ToBlob(result.data, "application/pdf");
				let pdfUrl = URL.createObjectURL(pdfBlob);
				this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir el documento, intente nuevamente o contacte a su administrador " + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}

	getTotalOfDetails(dte: IDte) {
		const isInternalTransfer = dte.guiaDespacho?.tipoTraslado === 5;
		let sumOfDetailsNeto: number = 0;
		let sumOfDetailsBruto: number = 0;
		let sumOfDetailsExento: number = 0;
		let globalDiscount: number = 0;
		globalDiscount = dte.descuentoGlobal;
		if (this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) {
			return 0;
		}
		else if(this.invoiceType === InvoiceType.LiquidacionFactura){
			return 1;
		}

		if (this.newDte instanceof FacturaExportacion || this.invoiceType == InvoiceType.FacturaExportacion) {
			sumOfDetailsExento = this.newDte.exento - this.newDte.descuentoGlobal;
		} else if (this.listElementsWithTax) {
			//resumme if tax are included in items so it needs to be backward calculated
			if (dte.impuestos > 0) {
				// if items dont contains specific taxes
				dte.detalleDte.forEach((detalle) => {
					if (!detalle.esExento) {
						let sumTaxRates = 0;
						if (detalle.impuestosAdicionales && detalle.impuestosAdicionales.length > 0) {
							sumTaxRates = detalle.impuestosAdicionales.reduce((sumTaxRates, tax) => sumTaxRates + tax.tasa, 0);
						}

						sumOfDetailsNeto += Math.round(detalle.total / (1 + sumTaxRates / 100 + this.porcentajeIva));
					} else {
						sumOfDetailsExento += detalle.total;
					}
				});
			} else {
				//if items only contains mainTax (IVA)
				dte.detalleDte.forEach((detalle) => {
					if (!detalle.esExento) {
						sumOfDetailsBruto += detalle.total;
					} else {
						sumOfDetailsExento += detalle.total;
					}
				});
				if (this.invoiceType == InvoiceType.Boleta) {
					sumOfDetailsNeto = sumOfDetailsBruto > 0 ? (sumOfDetailsBruto - globalDiscount) / (1 + this.porcentajeIva) : 0;
				} else {
					sumOfDetailsNeto = sumOfDetailsBruto / (1 + this.porcentajeIva);
				}
			}
		} else {
			//resumme if tax are excluded in items so they are simple calculated
			dte.detalleDte.forEach((detalle) => {
				if (!detalle.esExento) {
					sumOfDetailsNeto += detalle.total;
				} else {
					sumOfDetailsExento += detalle.total;
				}
			});
		}
		let total = 0;
		if (this.invoiceType == InvoiceType.Boleta && dte.codigoTipoDte != 41) {
			total = Math.round(sumOfDetailsNeto) + sumOfDetailsExento - (dte.impuestos > 0 ? Math.round(globalDiscount / (1 + this.porcentajeIva)) : globalDiscount);
		} else if (this.invoiceType == InvoiceType.FacturaExportacion) {
			total = sumOfDetailsExento;
		} else if (dte.codigoTipoDte == 34 || dte.codigoTipoDte == 41) {
			total = Math.round(sumOfDetailsNeto) + sumOfDetailsExento - globalDiscount;
		} else {
			total = Math.round(sumOfDetailsNeto) + sumOfDetailsExento - globalDiscount;
		}
		if (isInternalTransfer) {
			return total;
		}
		return total;
	}

	someNullDetail(dte: IDte): boolean {
		const isInternalTransfer = dte.guiaDespacho?.tipoTraslado === 5;
		if (this.invoiceType === InvoiceType.NotaCredito && this.tipoNota === 2) {
			return false;
		}

		return dte.detalleDte.some((detalle) => {
			return !isInternalTransfer && (detalle.total == 0 || detalle.cantidad == 0 || detalle.precioUnitario == 0);
		});
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}

	ngOnDestroy() {
		this.facturador.resetElements();
		this.destroySubscriptions$.next(true);
		this.destroySubscriptions$.unsubscribe();
		this.facturador.referencesListFromGuidesSubject.next([]);
		this.subscriptions.forEach((s) => s.unsubscribe());
	}

	cleanEmptyDetails() {
		this.newDte.detalleDte.forEach((detail) => {
			if (!detail.cantidad || detail.cantidad <= 0) {
				this.newDte.detalleDte = this.newDte.detalleDte.splice(this.newDte.detalleDte.indexOf(detail), 1);
			}
		});
		if (this.invoiceType == InvoiceType.LiquidacionFactura) {
			this.newDte.comisionesCargosDte.forEach((detail) => {
				if (!detail.cantidad || detail.cantidad <= 0) {
					this.newDte.comisionesCargosDte = this.newDte.comisionesCargosDte.splice(this.newDte.comisionesCargosDte.indexOf(detail), 1);
				}
			});
		}
	}

	reloadCurrentRoute() {
		let currentUrl = this.router.url;
		if (this.invoiceType == InvoiceType.FacturaExportacion) {
			this.router.navigateByUrl("ventas/exportaciones");
		} else if (this.invoiceType == InvoiceType.GuiaDespacho) {
			this.router.navigateByUrl("ventas/guias-despacho");
		} else if (this.invoiceType == InvoiceType.FacturaCompra) {
			this.router.navigateByUrl("compras/facturas-compras");
		} else {
			this.router.navigateByUrl("ventas/documentos-emitidos");
		}
	}

	AfterInvoicing() {
		this.createNewProductsFromMarkedItems(this.newDte.detalleDte, this.newDte.emisorId);
	}

	scrollToTop() {
		window.scroll(0, 0);
	}

	createNewProductsFromMarkedItems(itemList: DetalleDte[], currentEmisorId: string) {
		let list = [...itemList];
		let emisorId = JSON.parse(JSON.stringify(currentEmisorId));
		let productsToCreate = list.filter((item) => item.createCurrentProduct == true);
		let requestList = [];
		if (!productsToCreate || productsToCreate.length <= 0) {
			this.facturador.resetElements();
			this.reloadCurrentRoute();
		} else {
			productsToCreate.forEach((item) => {
				let req = this.productService.sendProductRequestFromDetalleDte(item, emisorId);
				requestList.push(req);
			});
			let zippedProductRequests = zip(...requestList);
			this.loading = true;
			let zipsub = zippedProductRequests
				.subscribe(
					(zippedResult) => {
						let message = "<p>Los siguientes productos han sido ingresados: <p>";
						message += "<ul>";
						zippedResult.forEach((result, i) => {
							message += "<li>" + (result as Response<Producto>).data + ": " + productsToCreate[i].nombre + "</li>";
						});
						message += "</ul>";
						Swal.fire({
							icon: "success",
							title: "Productos Agregados",
							html: message,
						});
						this.loading = false;
						this.reloadCurrentRoute();
					},
					(error) => {
						this.loading = false;
						let errorMessage = "No fue posible ingresar los productos";
						Swal.fire({
							icon: "error",
							title: "Ingreso de Productos",
							text: errorMessage,
						});
						this.reloadCurrentRoute();
					}
				)
				.add(() => {
					this.loading = false;
					this.newDte = new DteEmitido();
					this.facturador.resetElements();
					this.ref.detectChanges();
				});
		}
	}

	setDetailWithoutTax(externalDetail) {
		let detail = JSON.parse(JSON.stringify(externalDetail)) as DetalleDte;
		detail.precioUnitario = detail.precioUnitario / (1 + this.porcentajeIva);
		detail.recargo = detail.recargo / (1 + this.porcentajeIva);
		detail.descuento = detail.descuento / (1 + this.porcentajeIva);
		detail.subtotal = detail.precioUnitario * detail.cantidad - detail.descuento + detail.recargo;
		detail.total = detail.subtotal;
		return detail;
	}

	getStateFromRoute() {
		//obtain the state object from current route
		this.invoiceTypeByRoute = this.activatedRoute.paramMap.pipe(map(() => window.history.state));
	}

	getDocTypeParamFromStateRoute() {
		this.loading = true;
		this.invoiceTypeByRoute.subscribe((result) => {
			let value: number = result.invoiceType;
			this.loading = false;
			this.modificationsByInvoiceType(result.invoiceType);
			this.facturador.setCurrentInvoiceType(result.invoiceType);
			this.invoiceType = result["invoiceType"];

			let tipoDTE = new TipoDte();
			switch (this.invoiceType) {
				case InvoiceType.Factura:
					this.showTransporte = true;
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 33);
					break;
				case InvoiceType.Boleta:
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 39);
					break;
				case InvoiceType.NotaCredito:
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 61);
					break;
				case InvoiceType.NotaDebito:
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 56);
					break;
				case InvoiceType.FacturaExportacion:
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 110);
					break;
				case InvoiceType.GuiaDespacho:
					this.showTransporte = true;
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 52);
					break;
				case InvoiceType.FacturaCompra:
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 46);
					break;
				case InvoiceType.LiquidacionFactura:
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 43);
					break;
				default:
					tipoDTE = this.tipoDteSource.find((x) => x.codigosii == 33);
			}
			this.getFoliosDisponibles();
			this.getFormatSizes(this.tokenService.getCompany(), tipoDTE.tipoDteId);

			//  if (this.invoiceType == InvoiceType.GuiaDespacho || this.invoiceType == InvoiceType.Factura) this.showInGuide = true;
			//  else this.showInGuide = false;
			// if (this.invoiceType == InvoiceType.LiquidacionFactura) {
			//   this.dontShowInSettlement = true;
			//   this.showInSettlement = true;
			// }
			// else this.dontShowInSettlement = false;

			let dteExistente = result.dteExistente;
			if (dteExistente) {
				//CARGAR DATOS. LLAMAR A LA BD
				this.dteService
					.getInfoDetalleDte(dteExistente.dteId)
					.subscribe(
						(dte) => {
							this.receptor = dte.receptor;
							this.receptor.receptorId = dte.receptor.receptorId;
							this.dteExistente = dte.dteEmitido;
							this.dteExistente.receptorId = dte.receptor.receptorId;
							this.dteInvoice.rutReceptor = dte.receptor.rutString;
							this.newDte.razonSocial = dte.dteEmitido.razonSocial;
							this.newDte.receptorEnt = dte.receptor;
							this.newDte.receptorId = dte.receptor.receptorId;
							this.newDte.dteId = dte.dteEmitido.dteId;

							this.newDte.rutReceptor = dte.dteEmitido.rutReceptor;
							this.newDte.rutReceptorDv = dte.dteEmitido.rutReceptorDv;
							
							this.listElementsWithTax = false;
							// if (this.newDte instanceof FacturaExportacion) {
							// 	this.newDte.clienteInternacionalId = client.clienteInternacionalId;
							// 	this.newDte.razonSocial = client.razonSocial;
							// }

							// this.dteToShow = result.dteEmitido;
							// this.dteToShow.receptorAsociado = result.receptor;
							// this.dteToShow.importado = result.dteEmitido.importado;

							// //this.dteToShow.descuentoGlobal = result.descuentoRecargos != null && result.descuentoRecargos.length > 0 ? result.descuentoRecargos[0].valor : undefined;
							// this.dteToShow.receptorAsociado.razonSocial = result.receptor.razonSocial;
							// this.dteToShow.receptorAsociado.rutString = result.receptor.rutString;
							// this.dteToShow.detalleDte = result.detalleDtes as DetalleDte[];
							// this.dteToShow.impuestos = this.dteToShow.detalleDte.reduce((suma, detalle) => (suma += detalle.totalImpuestosAdicionales), 0);
							// //this.dteToShow = { ...this.dteToShow } as DteEmitido;

							this.ref.detectChanges();
						},
						(error) => {
							this.loading = false;
							this.ref.detectChanges();
							//this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error));
						}
					)
					.add(() => {
						this.loading = false;
						this.ref.detectChanges();
						// this.detailModal = this.modalService.open(modalRef, {
						// 	windowClass: "",
						// 	size: "lg",
						// 	centered: true,
						// });
					});
			}
		});
	}

	modificationsByInvoiceType(type: InvoiceType) {
		switch (type) {
			case InvoiceType.Boleta: {
				break;
			}
			case InvoiceType.FacturaCompra: {
				this.newDte = new FacturaCompra();
				break;
			}
			case InvoiceType.FacturaExportacion: {
				this.newDte = new FacturaExportacion();
				this.showInExportInvoice = true;
				break;
			}
			case InvoiceType.GuiaDespacho: {
				this.showInGuide = true;
				break;
			}
			case InvoiceType.LiquidacionFactura: {
				this.dontShowInSettlement = true;
				this.showInSettlement = true;
				break;
			}
			case InvoiceType.NotaDebito: {
				break;
			}
		}
	}

	solicitarCodigosAduana() {
		this.loading = true;
		this.facturador.getCodigosAduana().subscribe(
			(result) => {
				let codigos = result.data;
				codigos.unidadMedidas.forEach((unidad) => {
					unidad.nombreSigla = unidad.codigoArancelario + " - " + unidad.nombreUnidadMedida;
				});
				this.localStorage.saveCodigosAduana(codigos);

				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Codigos",
					text: "No fue posible obtener los códigos de aduanas para emitir una factura de exportación,recargue la pagina e intene nuevamente " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	exportWithErrors(newDte: FacturaExportacion): boolean {
		let transport = newDte.transporte;
		if (transport == undefined) {
			return true;
		}
		if (transport.haveTransport) {
			return !(transport.flete != undefined && transport.medidaPesoBruto != undefined && transport.medidaPesoNeto != undefined && transport.medidaTara != undefined && transport.paisReceptor != undefined && transport.pesoBruto != undefined && transport.pesoNeto != undefined && transport.seguro != undefined && transport.tara != undefined && transport.viaTransporte != undefined);
		} else {
			return false;
		}
	}

	returnToMaintainer() {
		let returnTo = "/";
		returnTo = this.setReturnUrl();
		this.router.navigateByUrl(returnTo);
	}

	setReturnUrl() {
		switch (this.invoiceType) {
			case InvoiceType.GuiaDespacho: {
				return "ventas/guias-despacho";
			}
			case InvoiceType.FacturaExportacion: {
				return "ventas/exportaciones";
			}
			case InvoiceType.FacturaCompra: {
				return "compras/facturas-compras";
			}
			default: {
				return "ventas/documentos-emitidos";
			}
		}
	}

	onSelect({ selected }) {
		this.selectedGuides.splice(0, this.selectedGuides.length);
		this.selectedGuides.push(...selected);
	}

	selectAll(event) {
		if (!this.selectedAllItemsInPage[0]) {
			if (this.selectedGuides.length > 0) {
				this.listaGuiasFacturables.map((dte) => {
					this.selectedGuides = this.selectedGuides.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
				});
			}
			this.selectedGuides.push(...this.listaGuiasFacturables);
			this.selectedGuides = [...this.selectedGuides];
			this.selectedAllItemsInPage[0] = true;
		} else {
			this.listaGuiasFacturables.map((dte) => {
				this.selectedGuides = this.selectedGuides.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
			});
			this.selectedAllItemsInPage[0] = false;
		}
	}
	consultaGuiasFacturablesCliente() {
		let usuarioId = (this.tokenService.getUser() as SessionUser).id;
		let emisorId = this.tokenService.getCompany();
		this.loading = true;
		if (this.facturador.selectedClient == undefined) {
			Swal.fire({
				icon: "error",
				title: "Error al consultar guias de despacho",
				text: "No ha seleccionado un cliente para consultar sus guias de despacho disponibles para facturar",
			});
			return;
		}
		this.facturador.checkForBillableGuides(emisorId, this.facturador.selectedClient.receptorId, usuarioId).subscribe(
			(result) => {
				this.loading = false;
				this.ref.detectChanges();
				if (result.data.length > 0) {
					this.listaGuiasFacturables = result.data;
					this.showGuideListInModal(this.listaGuiasModalRef);
				} else {
					Swal.fire({
						icon: "info",
						title: "Guias de Despacho Facturables",
						text: "No hay guias de despacho facturables para el cliente seleccionado",
					});
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en Guias de Despacho",
					text: "Error al obtener guias de despacho facturables para el cliente seleccionado",
				});
			}
		);
	}

	showGuideListInModal(modalRef) {
		this.selectedGuides = [];
		this.guiasModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
		});
	}
	processGuidesIntoInvoice() {
		this.guiasModal.close();
		//get references
		this.processGuideToReferences(this.selectedGuides);

		//get details
		this.processGuideToDetails(this.selectedGuides);
	}

	processGuideToReferences(list: DteEmitido[]) {
		if (list.length <= 40) {
			this.guideToIndividualReferencesList(list);
		} else {
			this.guideToGroupedReferenceItem(list);
		}
	}

	processGuideToDetails(list: DteEmitido[]) {
		if (list.length <= 40) {
			this.guidesToIndividualDetailList(list);
		} else {
			this.guidesToGroupedDetailList(list);
		}
	}

	guideToIndividualReferencesList(list: DteEmitido[]) {
		let referencesList: ReferenciaDteEmitido[] = [];
		list.forEach((dte) => {
			referencesList.push(this.guideToRef(dte));
		});

		this.facturador.referencesListFromGuidesSubject.next(referencesList);
	}

	guideToRef(item: DteEmitido): ReferenciaDteEmitido {
		let ref = new ReferenciaDteEmitido();
		ref.codigoTipoDteReferencia = item.codigoTipoDte.toString();
		ref.folioReferencia = item.folio.toString();
		ref.fechaDteReferenciado = item.fecha;
		ref.razonReferencia = "Guia de despacho " + ref.folioReferencia;
		return ref;
	}

	guideToGroupedReferenceItem(list: DteEmitido[]) {
		let ref = new ReferenciaDteEmitido();
		ref.codigoTipoDteReferencia = list[0].codigoTipoDte.toString();
		ref.fechaDteReferenciado = new Date();
		ref.razonReferencia = "FACTURACIÓN DE GUÍAS GLOBAL";
		ref.folioReferencia = "";
		list.forEach((item) => {
			ref.folioReferencia += item.folio.toString() + ", ";
		});
		this.facturador.referencesListFromGuidesSubject.next([ref]);
	}

	guidesToIndividualDetailList(list: DteEmitido[]) {
		let detailList: DetalleDte[] = [];
		list.forEach((g) => {
			g.detalleDte.forEach((d) => {
				this.adjustPrecioUnitarioRelatedToTotalItem(d);
				detailList.push(d);
			});
		});
		this.facturador.detailsListFromGuidesSubject.next(detailList);
	}

	adjustPrecioUnitarioRelatedToTotalItem(detalle: DetalleDte) {
		//if previoUNitario is slightly lower than total then adjust it, happen when getting details from guides
		if (detalle.precioUnidadMedida * detalle.cantidad < detalle.total && detalle.cantidad == 1) {
			detalle.precioUnitario = detalle.total;
		}
	}

	guidesToGroupedDetailList(list: DteEmitido[]) {
		let detailList: DetalleDte[] = [];
		list.forEach((g) => {
			if (g.detalleDte.some((d) => d.esExento)) {
				let exentosDetails = g.detalleDte.filter((d) => d.esExento);
				let afectoDetails = g.detalleDte.filter((d) => !d.esExento);
				detailList.push(this.guideDetailsToGroupedDetailItem(exentosDetails, g));
				detailList.push(this.guideDetailsToGroupedDetailItem(afectoDetails, g));
			} else {
				detailList.push(this.guideToGroupedDetailItem(g));
			}
		});
		this.facturador.detailsListFromGuidesSubject.next(detailList);
	}

	guideToGroupedDetailItem(guide: DteEmitido): DetalleDte {
		let detalle = new DetalleDte();
		detalle.dteId = guide.detalleDte[0].dteId;
		detalle.descripcion = "Guía Despacho Folio: " + guide.folio;
		detalle.cantidad = 1;
		detalle.precioUnitario = guide.neto;
		detalle.total = guide.neto;
		detalle.esExento = false;
		return detalle;
	}

	guideDetailsToGroupedDetailItem(details: DetalleDte[], guide: DteEmitido): DetalleDte {
		let detalle = new DetalleDte();
		detalle.dteId = details[0].dteId;
		details.forEach((d) => {
			detalle.precioUnitario += d.precioUnitario;
			detalle.total += d.total;
		});
		if (details[0].esExento) {
			detalle.descripcion = "Elementos Exentos Guía Folio: " + guide.folio;
			detalle.esExento = true;
			detalle.cantidad = 1;
		} else {
			detalle.descripcion = "Elementos Afectos Guía Folio: " + guide.folio;
			detalle.esExento = false;
			detalle.cantidad = 1;
		}
		return detalle;
	}

	getPdfOfInvoice(id: string, type: InvoiceType) {
		let req = this.getPdfRequest(id, type);
		req.subscribe(
			(res) => {
				let pdfBlob = this.utilities.convertB64ToBlob(res.data, "application/pdf");
				let pdfUrl = URL.createObjectURL(pdfBlob);
				this.popupCenter(pdfUrl, "Muestra de Documento", 600, 800);
			},
			(error) => {
				this.currentSwal.title = "Error en emisión";
				this.currentSwal.text = "No ha sido posible emitir el documento, intente obteniendo el pdf directamente desde el mantenedor. " + error.error ? this.utilities.setErrorMessageFromArray(error.error) : "";
				this.currentSwal.icon = "error";
				this.currentSwal.fire();
			}
		);
	}

	getPdfRequest(id: string, type: InvoiceType): Observable<Response<any>> {
		let pdfRequest;
		switch (type) {
			case InvoiceType.LiquidacionFactura: {
				pdfRequest = this.dteService.getPdfLiquidacion(id);
				return pdfRequest;
			}
			case InvoiceType.FacturaExportacion: {
				pdfRequest = this.dteExportaService.getPdf(id);
				return pdfRequest;
			}
			default: {
				pdfRequest = this.dteService.getPdf(id);
				return pdfRequest;
			}
		}
	}

	checkAndAddGuideReferences() {
		//if invoice is based in guide as references,add those references in the invoice request
		if (this.newDte.listaReferenciasDteEmitido.every((ref) => ref.codigoTipoDteReferencia == "52") && this.selectedGuides.length > 0) {
			this.newDte.guiasFacturadas = this.selectedGuides.map((guide) => guide.dteId);
		}
	}

	getFoliosDisponibles() {
		var codeDTE = this.foliosService.obtenerTipoDte(this.invoiceType);
		if(codeDTE != undefined){
			this.foliosService.getDataByType(this.currentEmisorId, this.currentSucursalId, codeDTE).subscribe(
				(res) => {
					this.foliosData = res.data;
					this.groupedFolios = this.groupArrayOfObjects(this.foliosData, "tipoDteId");
					//foreach tipoDteId sum foliosDisponibles y vencimiento mas cercano
					for (const tipoDteGroup of Object.entries(this.groupedFolios)) {
						let sumOfDteType = 0;
						if (tipoDteGroup != null && tipoDteGroup.length > 0) {
							(tipoDteGroup[1] as any[]).forEach((currentObj) => {
								if (currentObj["activo"]) {
									sumOfDteType += currentObj["foliosDisponibles"];
								}
							});
						}
						tipoDteGroup["suma"] = sumOfDteType;
						tipoDteGroup["nombre"] = this.getDteTypeName(tipoDteGroup[0]);
						tipoDteGroup["codigoSii"] = tipoDteGroup[1][0]["codigoSii"];
						this.listFolioResumen.push(tipoDteGroup);
						this.ref.detectChanges();
						this.utilities.sortAlphabeth(this.listFolioResumen, "nombre");
					}	
					//pass name of DteTypes
					this.informarTipoFolio(this.invoiceType);
				},
				(err) => {}
			);
		}
	}

	groupArrayOfObjects(list, key) {
		return list.reduce(function (rv, x) {
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}

	sendTipoFolio(codigo: number) {
		let grupoFolio = this.listFolioResumen.find((resumenTipo) => resumenTipo.codigoSii == codigo);
		if (grupoFolio) {
			this.facturador.passTipoCantidadFolio([grupoFolio.nombre, grupoFolio.suma]);
		} else {
			this.facturador.passTipoCantidadFolio(grupoFolio);
		}
		this.currentGrupoFolio = grupoFolio;
	}

	getDteTypeName(dteTypeId): string {
		return this.tipoDteSource.find((type) => type.tipoDteId == dteTypeId).nombre;
	}

	informarTipoFolio(type: InvoiceType) {
		if (this.listFolioResumen && this.listFolioResumen.length > 0) {
			switch (type) {
				case InvoiceType.Factura:
					this.sendTipoFolio(33);
					break;
				case InvoiceType.Boleta:
					this.sendTipoFolio(39);

					break;

				case InvoiceType.NotaCredito:
					this.sendTipoFolio(61);

					break;

				case InvoiceType.NotaDebito:
					this.sendTipoFolio(56);

					break;

				case InvoiceType.FacturaCompra:
					this.sendTipoFolio(46);

					break;
				case InvoiceType.FacturaExportacion:
					this.sendTipoFolio(110);

					break;
				case InvoiceType.GuiaDespacho:
					this.sendTipoFolio(52);

					break;
				case InvoiceType.LiquidacionFactura:
					this.sendTipoFolio(43);
					break;
				default:
					break;
			}
		}
	}
}
